import { render, staticRenderFns } from "./item-header.vue?vue&type=template&id=4d46f0a2&scoped=true"
import script from "./item-header.vue?vue&type=script&lang=js"
export * from "./item-header.vue?vue&type=script&lang=js"
import style0 from "./item-header.vue?vue&type=style&index=0&id=4d46f0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46f0a2",
  null
  
)

export default component.exports